module.exports = __webpack_public_path__ + "img/photo3.174f6291.png";